/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetRecordPorterHistoriesResponseData,
  GetRecordPorterHistoriesResponseDataFromJSON,
  GetRecordPorterHistoriesResponseDataFromJSONTyped,
  GetRecordPorterHistoriesResponseDataToJSON
} from './GetRecordPorterHistoriesResponseData'

/**
 *
 * @export
 * @interface GetRecordPorterHistoriesResponse
 */
export interface GetRecordPorterHistoriesResponse {
  /**
   *
   * @type {number}
   * @memberof GetRecordPorterHistoriesResponse
   */
  status?: number
  /**
   *
   * @type {GetRecordPorterHistoriesResponseData}
   * @memberof GetRecordPorterHistoriesResponse
   */
  data?: GetRecordPorterHistoriesResponseData
}

export function GetRecordPorterHistoriesResponseFromJSON(json: any): GetRecordPorterHistoriesResponse {
  return GetRecordPorterHistoriesResponseFromJSONTyped(json, false)
}

export function GetRecordPorterHistoriesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetRecordPorterHistoriesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetRecordPorterHistoriesResponseDataFromJSON(json['data'])
  }
}

export function GetRecordPorterHistoriesResponseToJSON(value?: GetRecordPorterHistoriesResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetRecordPorterHistoriesResponseDataToJSON(value.data)
  }
}
